import Skeleton from "@mui/material/Skeleton";

function Shimmer() {
  return (
    <div className="flex flex-col h-full gap-20 w-full">
      <Skeleton variant="rectangular" height="2rem" width="100%" />
      <Skeleton variant="rectangular" height="9.375rem" width="100%" />
      <Skeleton variant="rectangular" height="9.375rem" width="100%" />
    </div>
  );
}
export default Shimmer;
